module.exports = __webpack_public_path__ + "static/media/sontho-5.0dd098c6.png";